export default "__VITE_ASSET__BtBHC6fX__"